import i18n from '@signavio/i18n';
import { Divider, useStyles } from '@signavio/ui';
import { utils } from '../styles';
import { preview } from '../utils/StringUtils';
import { LinkButton } from './buttons';
import { useState } from 'react';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
function CollapsedText({
  length = 100,
  children
}) {
  const text = children.toString();
  const alwaysExpand = text.length <= length;
  const styles = useStyles(defaultStyles, {});
  const [isExpanded, setIsExpanded] = useState(alwaysExpand);
  return /*#__PURE__*/_jsxs("div", {
    ...styles,
    children: [/*#__PURE__*/_jsx("div", {
      ...styles('message'),
      children: isExpanded ? text : preview(text, length) + ' ...'
    }), !alwaysExpand && /*#__PURE__*/_jsxs("div", {
      children: [/*#__PURE__*/_jsx(Divider, {}), /*#__PURE__*/_jsx(LinkButton, {
        small: true,
        block: true,
        onClick: () => setIsExpanded(!isExpanded),
        children: isExpanded ? i18n('Hide text') : i18n('Show complete text')
      })]
    })]
  });
}
const calculatePadding = (fontSize, lineHeight) => utils.calculateAbsoluteLineHeight(fontSize, lineHeight) - utils.calculateAbsoluteLineHeight(fontSize, lineHeight) / 2;
const defaultStyles = ({
  font,
  lineHeight,
  spacing
}) => ({
  paddingLeft: spacing.small,
  paddingRight: spacing.small,
  paddingTop: calculatePadding(font.size.button, lineHeight),
  paddingBottom: calculatePadding(font.size.button, lineHeight),
  message: {
    whiteSpace: 'pre-wrap',
    wordBreak: 'break-word'
  }
});
export default CollapsedText;